import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { Link } from 'react-router';
import { fetchOrders, clearOrdersErrors, pageNavigation } from '../../actions';
import DialogModal from '../home/DialogModal';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  orders: PropTypes.any,
  orderDelete: PropTypes.bool,
  onOrderDisable: PropTypes.func.isRequired,
  admins: PropTypes.object.isRequired,
  salesChannels: PropTypes.object,
  onView: PropTypes.any,
};

class ShowOrders extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      deleteId: 0,
      alertOpen: false,
      alertMessage: '',
      delete: false,
      admin: {
        name: null,
        email: null,
        signupDate: '',
        password: null,
        role: null,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.orderDelete && (this.state.delete || nextProps.orders.delete)) {
      const orders = nextProps.orders;
      orders.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: '',
        orders,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: 0,
    });
  }

  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearOrdersErrors());
    this.props.dispatch(fetchOrders({ page: 1 }));
  }
  renderRows() {
    const styles = {
      rowStyle: { fontSize: '12px' },
      missingPayment: { fontSize: '12px', background: '#FAE752' }, //yellow
      reprints: { fontSize: '12px', background: '#FAB62D' }, //orange
      expressShipping: { fontSize: '12px', background: '#87ceeb' }, //blue
    }
    return this.props.orders.map(order => {
        var rowStyle = styles.rowStyle
        if (!(order && order.transactionType) && order.salesChannelId !== 4){
          rowStyle = styles.missingPayment
        } else if(Number(order.shippingAmount)> 9){
          rowStyle = styles.expressShipping
        } else if (order.salesChannelId === 4){
          rowStyle = styles.reprints
        }
        const statusAlert = order && order.alert && order.alert.replace(/['"]+/g, '')
        const salesChannelId = order.salesChannelId
        const orderSalesChannel= this.props.salesChannels.results.find(salesChannel =>salesChannel.id === salesChannelId)
        const salesChannelName = orderSalesChannel && orderSalesChannel.name
      return (
        <tr key={order.id} style={rowStyle}>
            <td>
              <div className="row">
                <div className="col" onClick={(e)=> { e.preventDefault(); this.props.dispatch(pageNavigation('view')) }}>
                  <Link to={`/orders/${order.id}`}>{order.confirmId}</Link>
                </div>
                <div className="col">{order.customerName}&nbsp;{order.customerLastName}</div>
              </div>
            </td>
            <td >
              <div className="row">
                <div className="col">{new Date(order.orderDate).toLocaleString()}</div>
                <div className="col">{order.status}</div>
                <div className="col">{(statusAlert!=='No Alerts') ? <div style={{color: 'red' }}> {statusAlert} </div> : statusAlert}</div>
                <div className="col">{salesChannelName}</div>
              </div>
            </td>
            {/* <td>{new Date(order.orderDate).toLocaleString()}</td>
            <td>{order.status}</td>
            <td>{(order.alert !=='No Alerts') ? <div style={{color: 'red' }}> {order.alert} </div> : order.alert}</td> */}
            <td className="row">
              <div className="col">{order.transactionType}</div>
              <div className="col">{order.totalAmount}</div>
            </td>
            <td className="action-buttons-table" style={{ padding: 0}}>
              <ActionButtons
              onEdit={`/orders/${order.id}`}
              // onView={`/orders/${order.id}`}
              // onDelete={() => this.handleOpen(item.id)}
              // onDisable={() => this.handleDisable(item)}
              // disabled={item.disabled}
            />
          </td>
        </tr>
      )
    });
  }
  render() {
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Order"
          dialogMessage="Do you really want to delete this order?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <table className="table table-striped">
          <thead className="table-head thead-light">
            <tr style={{fontSize: '12px'}}>
              <th scope="col">
                <div className="row">
                  <div className="col">Confirmation Id</div>
                  <div className="col">Customer Name</div>
                </div>
              </th>
              <th scope="col">
                <div className="row">
                  <div className="col">Order Date</div>
                  <div className="col">Order Status</div>
                  <div className="col">Processing Status</div>
                  <div className="col">Sales Channel</div>
                </div> 
              </th>
              <th scope="col">
                <div className="row">
                  <div className="col">Processor Type</div>
                  <div className="col">Order Total</div>
                </div>
              </th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRows()}
          </tbody>
        </table> 
      </div>
    );
  }
}

ShowOrders.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowOrders.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    orderDelete: state.orders.orderDelete,
    error: state.orders.error,
    admin: state.admins.admin,
    salesChannels: state.salesChannels,
  };
}

export default connect(mapStateToProps)(ShowOrders);


// WEBPACK FOOTER //
// ./src/components/orders/ShowOrders.js